export function getValueOrUndefined(value) {
    return value == undefined ? undefined : value;
}
export function throwIfNullOrUndefined(value, name) {
    if (value == undefined) {
        throw new Error(`Expected a ${name}`);
    }
    return value;
}
export function getArray(value) {
    const val = getValueOrUndefined(value);
    return val === undefined ? [] : val;
}
export function notNull(value) {
    return value != undefined;
}

//# sourceMappingURL=utils.js.map
